import { CreditCard } from "lucide-react";
import { Link } from "react-router-dom";
import { PRICING_ENABLED } from "../config";

export const EnrollPayButton = ({ label = "Enroll & Pay", className = "", variant = "primary" }) => {
  if (!PRICING_ENABLED) return null;
  const styles =
    variant === "secondary"
      ? "border border-border bg-secondary/40 text-foreground hover:bg-secondary"
      : "bg-primary text-primary-foreground hover:bg-primary/90 glow-cyan";
  return (
    <Link
      to="/checkout"
      data-testid="enroll-pay-btn"
      className={`inline-flex items-center justify-center gap-2 h-11 px-6 rounded-sm font-semibold transition-colors ${styles} ${className}`}
    >
      <CreditCard className="h-5 w-5" />
      {label}
    </Link>
  );
};
